export default __webpack_public_path__ + "static/media/page-ewisemaps.123106ae.jpg";